import * as products from 'app/mocks/data/catalogue/products/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order1: Order = {
    id: 101,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive1,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 100,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 500,
        },
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 500,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
    ],
}

export const order2: Order = {
    id: 102,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive2,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
    ],
}

export const order3: Order = {
    id: 103,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive3,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
    ],
}

export const order4: Order = {
    id: 104,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive1,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 6,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 6,
                },
            ],
        },
    ],
}

export const order5: Order = {
    id: 105,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive1,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
    ],
}

export const order6: Order = {
    id: 106,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive15,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product7,
            is_weight_quantity: true,
            quantity: 250,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive15,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product7,
                    is_weight_quantity: true,
                    quantity: 250,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
    ],
}

export const order7: Order = {
    id: 107,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive6,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 150,
        },
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 150,
                },
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
    ],
}

export const order8: Order = {
    id: 108,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive5,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 200,
        },
        {
            product: products.product5,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 200,
                },
                {
                    product: products.product5,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
    ],
}

export const order9: Order = {
    id: 109,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive7,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
    ],
}

export const order10: Order = {
    id: 110,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive2,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 150,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 150,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
    ],
}

export const order11: Order = {
    id: 111,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive9,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: true,
            quantity: 300,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: true,
                    quantity: 300,
                },
            ],
        },
    ],
}

export const order12: Order = {
    id: 112,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive3,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product9,
            is_weight_quantity: true,
            quantity: 250,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product9,
                    is_weight_quantity: true,
                    quantity: 250,
                },
            ],
        },
    ],
}

export const order13: Order = {
    id: 113,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive8,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product11,
            is_weight_quantity: true,
            quantity: 175,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product11,
                    is_weight_quantity: true,
                    quantity: 175,
                },
            ],
        },
    ],
}

export const order14: Order = {
    id: 114,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive4,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive4,
            changes: [
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product13,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
    ],
}

export const order15: Order = {
    id: 115,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive6,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product14,
            is_weight_quantity: true,
            quantity: 400,
        },
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product14,
                    is_weight_quantity: true,
                    quantity: 400,
                },
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
    ],
}

export const order16: Order = {
    id: 116,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive10,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
    ],
}

export const order17: Order = {
    id: 117,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive11,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product17,
            is_weight_quantity: true,
            quantity: 225,
        },
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive11,
            changes: [
                {
                    product: products.product17,
                    is_weight_quantity: true,
                    quantity: 225,
                },
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
    ],
}

export const order18: Order = {
    id: 118,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive12,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product19,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 350,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive12,
            changes: [
                {
                    product: products.product19,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 350,
                },
            ],
        },
    ],
}

export const order19: Order = {
    id: 119,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive13,
    site: sites.site2,
    price: 1,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product23,
            is_weight_quantity: true,
            quantity: 275,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive13,
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product23,
                    is_weight_quantity: true,
                    quantity: 275,
                },
            ],
        },
    ],
}

export const order20: Order = {
    id: 120,
    status: StatusOrder.enum.IN_PREPARATION,
    konvive: konvives.konvive14,
    site: sites.site1,
    price: 1,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: true,
            quantity: 450,
        },
        {
            product: products.product25,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-1)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive14,
            changes: [
                {
                    product: products.product24,
                    is_weight_quantity: true,
                    quantity: 450,
                },
                {
                    product: products.product25,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
    ],
}
